var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { FormItemTypes } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../../../../assets/customIcons";
import { ReactComponent as CloseIcon } from "../../../../../../assets/images/closeIcon.svg";
import { DynamicFormBuilderContainer } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { AreaFieldReportsKeys } from "../../../../services/entity";
import { EditIcon } from "../../../../../fieldFailureReports/assets/svg";
import { vehicleDefectivePartDetails } from "../../../AFRs/components/ViewComponent/generalTAB";
import { HistoryTab } from "../../../FFRs/components/HistoryTab";
import { ChildFF } from "../../../FFRs/components/ChildFFR";
import { areaFieldFailureReportsGetAPI } from "../../../../services/apiCalls";
import { basicDetailsAndVehicleDetails } from "../../../../../fieldFailureReports/components/fieldFailureReportCreateForm/BasicDetailsAndVehicleDetails";
import { CourierDetails } from "../../../AFRs/components/ViewComponent/courierDetails";
import { problemDescriptionOrChangeView } from "../../../AFRs/components/ViewComponent/problemDescriptionTAB";
import { StateWiseFailuresReported } from "../StateWiseFailuresReported";
import { useAppSelector } from "../../../../../../store/hooks";
var AreaFieldReportDetailsDesktop = function (_ref) {
    var _crud$AreaFieldReport;
    var onClose = _ref.onClose, data = _ref.data;
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var BasicDetailsAndVehicleDetails = basicDetailsAndVehicleDetails(true);
    var GenralViewSection = __spreadArray(__spreadArray([], BasicDetailsAndVehicleDetails, true), [{
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: true,
            elements: __spreadArray(__spreadArray([{
                    type: FormItemTypes.Custom,
                    name: 'CourierData',
                    columnSize: true,
                    element: CourierDetails
                }], vehicleDefectivePartDetails, true), [{
                    type: FormItemTypes.Custom,
                    name: 'StatewiseCount',
                    columnSize: true,
                    element: StateWiseFailuresReported
                }], false)
        }], false);
    var problemDescriptionOrChangeSequence = __spreadArray([], problemDescriptionOrChangeView, true);
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "supplier",
            columnSize: 12,
            mt: 3,
            bgcolor: "overlay.white",
            flexDirection: "row",
            justifyContent: "space-between",
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: "",
                    columnSize: data.Status === 'Open' ? 7 : 9,
                    display: "flex",
                    spacing: 0,
                    pl: 2,
                    item: false,
                    elements: [{
                            type: FormItemTypes.Box,
                            name: "",
                            display: "flex",
                            flexDirection: "row",
                            mt: 1,
                            columnSize: 11,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "DocumentName",
                                    valueGetter: function (state) { return "AFR details - ".concat(state.AFRDocumentName); },
                                    fontWeight: "strong",
                                    fontSize: "xl",
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: "Status",
                                    value: function (state) { return state.Status; },
                                    columnSize: 0,
                                    color: "info",
                                    sx: {
                                        ml: 1,
                                        mt: 0.5,
                                        borderRadius: 1
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 1,
                    alignItems: "center",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, (data === null || data === void 0 ? void 0 : data.Status) === 'Open' ? {
                            type: FormItemTypes.Button,
                            name: '',
                            columnSize: 0,
                            startIcon: /*#__PURE__*/ React.createElement(EditIcon, null),
                            variant: "outlined",
                            color: 'primary',
                            children: "Edit",
                            onClick: function () {
                                if (data !== null && data !== void 0 && data.id) {
                                    navigate("/areaFieldReports/afr/".concat(data === null || data === void 0 ? void 0 : data.id));
                                    onClose();
                                }
                            }
                        } : null, {
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: "12px",
                                width: "12px"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose(false);
                            },
                            sx: {
                            // padding: '12px'
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.Divider,
            name: "",
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: "",
            sx: {
                pt: 0
            },
            columnSize: true,
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "Stepper",
                    label: "",
                    value: null,
                    tabs: ((_crud$AreaFieldReport = crud[AreaFieldReportsKeys.get]) === null || _crud$AreaFieldReport === void 0 || (_crud$AreaFieldReport = _crud$AreaFieldReport.data) === null || _crud$AreaFieldReport === void 0 ? void 0 : _crud$AreaFieldReport.Status) === "Resent by PSG" ? [{
                            id: "0",
                            label: "General",
                            elements: GenralViewSection
                        }, {
                            id: "1",
                            label: "Problem description OR Change sequence",
                            elements: problemDescriptionOrChangeSequence
                        }, {
                            id: "2",
                            label: "History",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "history",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: HistoryTab
                                }]
                        }, {
                            id: "3",
                            label: "ChildFFR",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "childFFR",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: ChildFF
                                }]
                        }] : [{
                            id: "0",
                            label: "General",
                            elements: GenralViewSection
                        }, {
                            id: "1",
                            label: "Problem description OR Change sequence",
                            elements: problemDescriptionOrChangeSequence
                        }, {
                            id: "3",
                            label: "ChildFFR",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "childFFR",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: ChildFF
                                }]
                        }],
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable"
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        p: 2,
        sx: {
            paddingTop: {
                md: "60px",
                lg: "60px"
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            gap: "20px"
        },
        formData: formData,
        getFormAPI: areaFieldFailureReportsGetAPI,
        getKey: AreaFieldReportsKeys.get,
        getRequest: {
            id: data === null || data === void 0 ? void 0 : data.id
            // id : '80a58080-94c9-404a-ba0e-f42b70a9a0fc'
        }
    })));
};
export default AreaFieldReportDetailsDesktop;
